import {
  IObjektVy,
  IBusinessCollectionProps,
  BusinessCollectionCompType,
} from '../../../../../Types/ObjektVy';
import { ObjektVyKort } from './ObjektVyKort/ObjektVyKort';

/**
Skapar en objektvy utifrån en lista av objektvyer.
*/
export const objektVyGrupp = (
  /** typ för vyn, ska kunna användas som key för vyns komponent */
  typ: string,
  /** lista av vyer, en sträng kan användas som alternativ för att skapa en fältvy */
  vyer: Array<IObjektVy | string>,
  caption?: string
): IObjektVy => {
  return {
    type: 'ObjektVy',
    id: typ,
    info: { komponentMedRubrik: true },
    def: bmod => {
      const cardCaption = caption ?? bmod.RootType.SOLabel;
      const comp: BusinessCollectionCompType = (
        runtimeProps: IBusinessCollectionProps
      ) => (
        <ObjektVyKort
          {...runtimeProps}
          vyer={vyer}
          caption={cardCaption}
          bmod={bmod}
        />
      );
      return {
        caption: cardCaption,
        comp: comp,
        dataDependencies:
          vyer?.flatMap(vy =>
            typeof vy === 'string' ? vy : vy.def(bmod).dataDependencies ?? []
          ) ?? [],
      };
    },
  };
};
